import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import dayjs from "dayjs";
import Helmet from "react-helmet";

import GetGeometryType from "./GetGeometryType.graphql";
import Tags from "./Tags";
import { StyledDetailHeader } from "../../../components/styles";

/**
 * Name of the revision on screen. `geometryType` resolves through
 * `["public", "latest"]`, so on a published Geometry Type the heading otherwise
 * shows the published name while the editor below shows the one being edited.
 */
function revisionName(raw: string | undefined): string | undefined {
    if (!raw) return undefined;

    const translations = JSON.parse(raw)?.name;
    if (!Array.isArray(translations) || !translations.length) return undefined;

    const translation = translations.find((candidate) => candidate?.language === "en") ?? translations[0];

    return translation?.text;
}

export default function Title(props) {
    const { id, revisionID } = props;

    const getGeometryType = useQuery(
        gql(GetGeometryType),
        {
            variables: {
                id,
                revisionID,
            },
        },
    );

    if (getGeometryType.loading || getGeometryType.error || !getGeometryType.data?.geometryType) return null;

    const isDeprecated = getGeometryType.data.geometryType.deprecated;
    const isPublic = getGeometryType.data.geometryType.revision?.tags?.includes("public");
    const nameText = revisionName(getGeometryType.data.geometryType.revision?.raw)
        ?? getGeometryType.data.geometryType.name[0]?.text
        ?? "Untitled Geometry Type";

    return (
        <StyledDetailHeader>
            <Helmet>
                <title>GT - { nameText } - taxonomy</title>
            </Helmet>
            <div className="title-row">
                <h1 title={ nameText }>{ nameText }</h1>
                <div className="status-badges">
                    { isDeprecated && <span className="badge deprecated">Deprecated</span> }
                    { isPublic ? (
                        <span className="badge public">Public</span>
                    ) : (
                        <span className="badge draft">Draft</span>
                    ) }
                    <Tags
                        id={ id }
                        revisionID={ revisionID }
                    />
                </div>
            </div>
            <div className="meta-row">
                {
                    getGeometryType.data.geometryType.revision && (
                        <time>Created: { dayjs(getGeometryType.data.geometryType.revision.createdAt).format("YYYY-MM-DD HH:mm:ss") }</time>
                    )
                }
            </div>
        </StyledDetailHeader>
    );
}
